import classNames from 'classnames';
import * as React from 'react';

export interface NavbarWrapperProps {
  aside: React.ReactNode;
  children: React.ReactNode;
  isAsideOpen: boolean;
  navbar: React.ReactNode;
}

export const NavbarWrapper: React.VFC<NavbarWrapperProps> = ({
  aside,
  children,
  isAsideOpen,
  navbar,
}) => (
  <div
    className={classNames('vb-navbar-wrapper', {
      'vb-navbar-wrapper--aside-open': isAsideOpen,
      'vb-navbar-wrapper--aside-closed': !isAsideOpen,
    })}
  >
    {navbar}
    <div className="vb-navbar-wrapper-body">
      <div className="vb-navbar-wrapper-aside">{aside}</div>
      <div className="vb-navbar-wrapper-children">{children}</div>
    </div>
  </div>
);
